import React from 'react';
import './Subservices.scss';

const Subservices = ({ subservicesTitles }) => {
    return (
        <div className="subservices-container container">
            <div className="subservices-header">
                <h2>Services</h2>
                <p>{subservicesTitles.header}</p>
            </div>
            <div className="subservices-grid">
                {subservicesTitles.subservices.map((service, index) => (
                    <div key={index} className="service-card">
                        <div className="icon-container">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/services/${service.iconFileName}`}
                                alt={service.title}
                            />
                        </div>
                        <h3>{service.title}</h3>
                        {service.subtitle && <p>{service.subtitle}</p>}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Subservices;
